import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import axios from 'axios';
axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status == 401) {
    _Message.error('登录超时');

    localStorage.setItem('userStatus', 'logout');
    window.location.href = '/login';
  }

  return Promise.reject(error);
});